var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9821 4.18669L9.56137 0.549659C9.88698 0.218798 10.4149 0.218798 10.7405 0.549659C11.0661 0.88052 11.0661 1.41695 10.7405 1.74781L6.57166 5.98392C6.24605 6.31478 5.71814 6.31478 5.39253 5.98392L1.2237 1.74781C0.898091 1.41695 0.898091 0.88052 1.2237 0.549659C1.5493 0.218798 2.07722 0.218798 2.40282 0.549659L5.9821 4.18669Z",
    fill: "#2E2E2E",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaret);
export default __webpack_public_path__ + "static/media/caret.5d7c47f764751abe73a570d3b30ff7b7.svg";
export { ForwardRef as ReactComponent };